<template>
  <!-- Allows to find matches in the database based on a text -->
  <div id="mainContainer">
    <help-popup v-bind:show="showHelp" v-bind:text="pageText.help.text[selectedLang]" v-bind:title="pageText.help.title[selectedLang]" v-bind:selectedLang="selectedLang"></help-popup>
     <!-- Display title with an help button -->
    <div id="objectTitleContainer">
      <div id="helpButtonSizer">
      </div>
      <div id="objectTitleSizer">
        <h1>{{pageText.title[selectedLang]}}</h1>
      </div>
      <div id="helpButtonSizer" v-on:click="triggerHelp(true)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle-fill" viewBox="0 0 16 16">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
        </svg>
      </div>
    </div>
    <!-- Where user can type a text -->
    <div id="formSection">
      <label>{{pageText.formSection.label[selectedLang]}}</label><br/>
      <div id="textSpace">
        <textarea v-model="userText"/>
      </div>
      <div id="buttons">
        <button class="btn btn-primary" v-on:click="translate('fr')">{{pageText.formSection.buttonFr[selectedLang]}}</button>
        <button class="btn btn-primary" v-on:click="translate('nl')">{{pageText.formSection.buttonNl[selectedLang]}}</button>
      </div>
    </div>
    <!-- Where outputs are shown -->
    <div id="answerSection">
      <!-- Loading widget to keep user waiting while treatement (can take a while) -->
      <div id="waiting" v-if="requestInProcess">
        <label>{{pageText.answerSection.labelWait[selectedLang]}}</label>
        <div id="loadingCircle">
          <img src="../assets/loading.gif"/>
        </div>
      </div>
      <!-- Shows response -->
      <div id="response" v-if="showAnswer">
        <h2>{{pageText.answerSection.result[selectedLang]}}</h2>
        <div id="answerTextContainer">
          <span v-if="encounterError">{{errorMessage}}</span>
          <span v-for="item in response" v-bind:key="item">
            <span v-if="item[1] != ''"><router-link class="identifiedWord" v-bind:to="`/${userLang}/${item[0]}`" v-html="`${item[0]}`"></router-link></span>
            <!-- <span class="determinant" v-else-if="isDeterminant(item[0])">{{item[0]}}</span> -->
            <span v-else>
              <a class="unidentifiedWord" v-if="userLang === 'fr'" v-bind:href="`https://dictionary.reverso.net/french-english/${item[0]}`">{{item[0]}}</a>
              <a class="unidentifiedWord" v-if="userLang === 'nl'" v-bind:href="`https://dictionary.reverso.net/dutch-english/${item[0]}`">{{item[0]}}</a>
            </span>
            <span>&nbsp;</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getTextTranslationHelp} from '../utils.js'
import HelpPopup from './HelpPopup.vue'

export default {
  name: 'TranslationAssistant',
  props : {
    selectedLang : String
  },
  components : {
    HelpPopup
  },
  methods : {
    /**
     * Returns true if `word` is a determinant in the current language
     */
    isDeterminant(word){
      let determinant = [];
      if (this.userLang === "fr") {
        determinant = ['à','en','le', 'la', 'les', "l'", 'un', 'une', 'des', 'ce', 'cette', 'cet', 'ces', '?', '!', '.', ',', 'de', 'son', 'et', "d'"];
      } else {
        determinant = ['de', 'het', 'een', '?', '!', '.', ','];
      }
      return determinant.includes(word.toLowerCase())
    },

    /**
     * Function triggered when a button is clicked
     * 
     * @param lang either 'nl' or 'fr'
     */
    translate(lang){
      // Clean variables 
      this.response = "";
      this.errorMessage = ""
      this.showAnswer = false;
      this.userLang = lang;
      // Show the loading widget
      this.requestInProcess = true;
      // Ask server for matches in user's text
      getTextTranslationHelp(this.userText, lang, (d) => {
        // In case of success
        this.response = d;
        this.showAnswer = true;
        // Ne errors were encountered
        this.encounterError = false;
        // Hide the loading widget
        this.requestInProcess = false;
      }, (e) => {
        // In case of error, shows error message
        this.showAnswer = true;
        this.encounterError = true;
        this.requestInProcess = false;
        this.errorMessage = e;
      })
    },
    /**
    * Set showHelp to `show`
    * 
    * @param show (boolean) : Value to be set for showHelp
    */
    triggerHelp(show){
      this.showHelp = show;
    }
  },
  data (){
    return {
      // Page static text, available in french,
      // english and dutch
      pageText : {
        title : {
          en : "Translation assistant",
          fr : "Aide à la traduction",
          nl : "Vertaalhulp",
        },
        formSection : {
          label : {
          en : "Text to translate : ",
          fr : "Texte à traduire : ",
          nl : 'Te vertalen tekst : '
          },
          buttonFr : {
            en : "Translate from French to English",
            fr : "Traduire du français vers l'anglais",
            nl : "Vertalen van frans naar engels"
          },
          buttonNl : {
            en : "Translate from Dutch to English",
            fr : "Traduire du néerlandais vers l'anglais",
            nl : "Vertalen van nederlands naar engels"
          },
        },
        answerSection : {
          labelWait : {
            en : "Please wait, translation may take some time",
            fr : "Veuillez patienter, la traduction peut prendre du temps",
            nl : "Even geduld, vertaling kan even duren"
          },
          result : {
            en : "Result :",
            fr : "Résultat :",
            nl : "Resultaat :"
          }
        },
        help : {
          title : {
            fr : "Utilisation de l'aide à la traduction",
            en : "Using the translation assistant",
            nl : "De vertaalhulp gebruiken"
          },
          text : {
            fr : "Copiez un texte entier dans la zone de saisie. L'application compare les mots à ceux présents dans la base de données et ajoute les traductions trouvées au texte/à la liste. Vous obtenez également des liens vers des dictionnaires de traduction et un site de traduction.",
            en : "Copy a whole text into the input field. The application compares the words with those in the database and adds the found translations to the text/list. You also get links to translation dictionaries and a translation site.",
            nl : "Kopieer een hele tekst in het invoerveld. De toepassing vergelijkt de woorden met die in de database en voegt de gevonden vertalingen toe aan de tekst/lijst. U krijgt ook links naar vertaalwoordenboeken en een vertaalsite."
          }
        }
      },
      // What user types
      userText : "",
      // Language choosed by user when he clicked on a button (fr or nl)
      userLang : "",
      // What server answers
      response : "",
      // Hide/Show the loading widget
      requestInProcess : false,
      // Tells if an error has been encountered while
      // communicating with server 
      encounterError : false,
      errorMessage : "",
      showAnswer : false,
      showHelp : false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h1 {
  font-size: 2vw;
}

#mainContainer {
  width: 100%;
  height: 100%;
  display : flex;
  flex-direction: column;
  justify-content: space-between;
  margin: auto;
}

#title{
  text-align: center;
}

label {
  font-weight: bold;
}

#formSection{
  height: 10rem;
  width : 90%;
  margin: auto;
}

#textSpace {
  width: 100%;
  height: 10em;
  font-size: 100%;
}

#formSection textarea{
  width: 100%;
  height: 100%;
}

#buttons {
  display: flex;
  justify-content: space-around;
}

#buttons button {
  width: 20%;
}

#answerSection {
  width: 90%;
  margin: auto;
  margin-top : 100px;
}

#answerTextContainer {
  width: 100%;
  text-align: justify;
}

#answerTextContainer span {
  word-wrap: break-word;
}

#waiting {
  width: 80%;
  text-align: center;
  margin: auto;
}

/* Response text effects */

.determinant, .unidentifiedWord, .identifiedWord {
  text-decoration: none;
}

.identifiedWord{
  color : #0d6efd;
  cursor: pointer;
}

.unidentifiedWord{
  color : black;
  cursor: pointer;
}

.determinant {
  color : gray
}

@media screen and (max-width: 850px) {


#answerSection {
  width: 90%;
  margin: auto;
  margin-top : 50px;
}

  #formSection{
    height: 50vh;
  }

  /* #mainContainer{
    height: auto;
  } */

  h1 {
    font-size: 8vw;
  }

  #buttons {
    flex-direction: column;
  }

  #answerTextContainer {
    width: 100%;
  }

  #buttons button {
    width: 100%;
  }

  #textSpace {
    height: 80%;
    font-size: 80%;
  }
}

@media screen and (max-width: 850px) and (orientation : landscape){
  h1 {
    font-size: 5vw;
  }
  
  #formSection{
    height: 60vh;
  }

  #textSpace {
    height: 70%;
  }

  #buttons {
    flex-direction: row;
  }

  #buttons button {
    width: 50%;
  }
}
</style>
